import { host } from "@Services/url";
import React from "react";
import ReactDOM from "react-dom";

const GreatAgent = () => {
  const { monthlyVisitors, inquiryUsers } = window?.inquiry || {};
  if (!window?.tags?.includes("好業代")) return <></>;

  return (
    <div
      style={{
        background: " linear-gradient(180deg,#3264ff, #5c8aff)",
        width: "100%",
        height: "80px",
        borderRadius: "0px 0px 8px 8px",
        padding: "11px 26px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "-30px",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
        <div style={{ fontSize: "22px", fontWeight: "700", color: "#fff" }}>跟他一樣加入8891業代</div>
        <div className='text-18 text-[#fff]' style={{ fontSize: "18px", color: "#fff" }}>
          每月<span style={{ color: "#FFEA01" }}>{monthlyVisitors || 0}</span>
          潛客訪問8891，已助力
          <span style={{ color: "#FFEA01" }}>{inquiryUsers || 0}</span>買家購買新車
        </div>
      </div>

      <a
        href={`${host.c}/agent/investment?globalSource=買車頁-招攬業代`}
        target='_blank'
        id='good-agent-entry'
        style={{
          height: "40px",
          background: "#fff",
          borderRadius: "8px",
          padding: "0 26px",
          lineHeight: "40px",
          color: "#3264FF",
          fontSize: "18px",
          fontWeight: "bold",
          cursor: "pointer",
          textDecoration: "none",
        }}
      >
        立即加入
      </a>
    </div>
  );
};

const $Agent = document.getElementById("greatAgent");

$Agent && ReactDOM.render(<GreatAgent />, $Agent);
